import { useState } from 'react';
import { useCredits } from '../hooks';
import { CreditBalanceCard, SpendingSummary, TransactionHistory } from '../components';

export function CreditsPage() {
  const {
    balance,
    spendingSummary,
    transactions,
    transactionsTotal,
    loading,
    loadingTransactions,
    error,
    refresh,
    loadMoreTransactions,
    hasMoreTransactions,
  } = useCredits();

  const [showTransactions, setShowTransactions] = useState(false);

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      <div className="flex items-center justify-between mb-8">
        <h1 className="text-2xl font-bold text-foreground">Credits</h1>
        <button
          onClick={refresh}
          disabled={loading}
          className="px-4 py-2 text-sm font-medium text-primary-foreground bg-primary rounded-lg hover:bg-primary/90 disabled:opacity-50"
        >
          {loading ? 'Refreshing...' : 'Refresh'}
        </button>
      </div>

      {error && (
        <div className="mb-6 p-4 bg-destructive/10 border border-destructive/20 rounded-lg text-destructive">
          {error}
        </div>
      )}

      <div className="space-y-6">
        <CreditBalanceCard balance={balance} loading={loading} />

        <SpendingSummary categories={spendingSummary} loading={loading} />

        <div>
          <button
            onClick={() => setShowTransactions((v) => !v)}
            className="text-sm font-medium text-primary hover:text-primary/80 mb-4"
          >
            {showTransactions
              ? 'Hide transactions'
              : `Show all transactions (${transactionsTotal})`}
          </button>

          {showTransactions && (
            <TransactionHistory
              transactions={transactions}
              total={transactionsTotal}
              loading={loading}
              loadingMore={loadingTransactions}
              hasMore={hasMoreTransactions}
              onLoadMore={loadMoreTransactions}
            />
          )}
        </div>
      </div>
    </div>
  );
}
